import { MembershipItemType } from '@spike/membership-model';
import { convertToPet } from '@spike/pets-action';
import moment from 'moment-timezone';
var mapItemType = function (itemType) {
    switch (itemType) {
        case 'Service':
            return MembershipItemType.SERVICE;
        case 'BusinessProduct':
            return MembershipItemType.PRODUCT;
        case 'AddonService':
            return MembershipItemType.ADD_ON;
        default:
            throw new Error("Unknown item type: ".concat(itemType));
    }
};
var mapItemTypeToSave = function (itemType) {
    switch (itemType) {
        case MembershipItemType.SERVICE:
            return 'Service';
        case MembershipItemType.PRODUCT:
            return 'BusinessProduct';
        case MembershipItemType.ADD_ON:
            return 'AddonService';
        default:
            throw new Error("Unknown item type: ".concat(itemType));
    }
};
export var convertToMembership = function (membershipDto) { return ({
    id: membershipDto.id,
    marketplaceID: membershipDto.marketplace_id,
    uuid: membershipDto.uuid,
    name: membershipDto.name,
    description: membershipDto.description,
    enrollmentType: membershipDto.enrollment_type,
    rolloverUsage: membershipDto.rollover_usage,
    rolloverBillingCycles: membershipDto.rollover_billing_cycles,
    billingFrequency: membershipDto.billing_frequency,
    onlineBooking: membershipDto.online_booking,
    subscribedCount: membershipDto.subscribed_count,
    canceledCount: membershipDto.canceled_count,
    pausedCount: membershipDto.paused_count,
    active: membershipDto.active,
    deleted: membershipDto.deleted,
    createdAt: membershipDto.created_at,
    updatedAt: membershipDto.updated_at,
    total: membershipDto.total,
    totalSales: membershipDto.total_sales,
    membershipItems: membershipDto.membership_items.map(convertToMembershipItem),
}); };
export var convertToMembershipItem = function (membershipItemDto) { return ({
    id: membershipItemDto.id,
    itemName: membershipItemDto.item_name,
    marketplaceID: membershipItemDto.marketplace_id,
    membershipID: membershipItemDto.membership_id,
    itemID: membershipItemDto.item_id,
    itemType: mapItemType(membershipItemDto.item_type),
    uuid: membershipItemDto.uuid,
    quantity: membershipItemDto.quantity,
    amount: membershipItemDto.amount,
    unlimited: membershipItemDto.unlimited,
    total: membershipItemDto.total,
    left: membershipItemDto.left
}); };
export var convertToSaveDto = function (membership) {
    var _a;
    return ({
        marketplace_id: membership.marketplaceID,
        name: membership.name,
        description: membership.description,
        enrollment_type: membership.enrollmentType,
        rollover_usage: membership.rolloverUsage,
        rollover_billing_cycles: membership.rolloverBillingCycles,
        billing_frequency: (_a = membership.billingFrequency) !== null && _a !== void 0 ? _a : '',
        online_booking: membership.onlineBooking,
        active: membership.active,
        deleted: membership.deleted,
        membership_items_attributes: membership.membershipItems.map(function (item) { return ({
            marketplace_id: item.marketplaceID,
            item_id: item.itemID,
            item_type: mapItemTypeToSave(item.itemType),
            quantity: item.quantity,
            amount: item.amount,
            unlimited: item.unlimited
        }); })
    });
};
export var convertToEnrollmentPending = function (dto) { return ({
    id: dto.id,
    marketplaceId: dto.marketplace_id,
    membershipId: dto.membership_id,
    customerId: dto.customer_id,
    orderId: dto.order_id,
    uuid: dto.uuid,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at,
    canceledAt: dto.canceled_at,
    pausedAt: dto.paused_at,
    petIds: dto.pet_ids,
    paymentMethodId: dto.payment_method_id
}); };
export var convertToEnrollment = function (dto, masterData, marketplace, timeZone) { return ({
    id: dto.id,
    clientName: dto.client_name,
    membership: convertToMembership(dto.membership),
    pets: dto.pets.map(function (petDto) { return convertToPet(masterData, marketplace, timeZone, petDto); }),
    startDate: moment(dto.start_date).tz(timeZone),
    endDate: dto.end_date ? (moment(dto.end_date, moment.ISO_8601).isValid() ? moment(dto.end_date).tz(timeZone) : dto.end_date) : '',
    nextBillingDate: dto.next_billing_date ? moment(dto.next_billing_date).tz(timeZone) : null,
    status: dto.status,
    totalAmount: dto.total_amount,
    paymentMethod: dto.payment_method ? {
        id: dto.payment_method.id,
        uuid: dto.payment_method.uuid,
        name: dto.payment_method.brand,
        lastDigits: dto.payment_method.last4,
        pspToken: dto.payment_method.psp_token,
        expirationMonth: dto.payment_method.expiration_month,
        expirationYear: dto.payment_method.expiration_year,
        holderName: dto.payment_method.name,
        primary: dto.payment_method.primary
    } : null,
    paymentLink: dto.payment_link,
    paid: dto.paid,
    cancellationReason: dto.cancellation_reason,
    canceledAt: dto.canceled_at ? moment(dto.canceled_at).tz(timeZone) : null,
    pausedAt: dto.paused_at ? moment(dto.paused_at).tz(timeZone) : null,
    orderId: dto.order_id,
    pastDueEnrollments: dto.past_due_enrollments ? dto.past_due_enrollments.map(function (pastDueEnrollmentDto) { return convertToPastDueEnrollment(pastDueEnrollmentDto, timeZone); }) : []
}); };
export var convertToPastDueEnrollment = function (dto, timeZone) { return ({
    id: dto.id,
    marketplaceId: dto.marketplace_id,
    membershipId: dto.membership_id,
    customerId: dto.customer_id,
    orderId: dto.order_id,
    uuid: dto.uuid,
    createdAt: moment(dto.created_at).tz(timeZone),
    updatedAt: dto.updated_at ? moment(dto.updated_at).tz(timeZone) : null,
    canceledAt: dto.canceled_at ? moment(dto.canceled_at).tz(timeZone) : null,
    pausedAt: dto.paused_at ? moment(dto.paused_at).tz(timeZone) : null,
    petIds: dto.pet_ids,
    paymentMethodId: dto.payment_method_id,
    cancellationReason: dto.cancellation_reason,
    recurringUuid: dto.recurring_uuid
}); };
export var convertToCheckoutEnrollments = function (dto, timeZone) { return dto
    .map(function (orderItemDto) { return ({
    orderItemId: orderItemDto.order_item_id,
    enrollments: orderItemDto.enrollments.map(function (enrollmentDto) { return ({
        enrollmentId: enrollmentDto.id,
        recurringUuid: enrollmentDto.recurring_uuid,
        createdAt: moment(enrollmentDto.created_at).tz(timeZone),
        status: enrollmentDto.status,
        membership: {
            id: enrollmentDto.membership_id,
            name: enrollmentDto.membership_name,
        },
        items: {
            total: enrollmentDto.item_total,
            left: enrollmentDto.item_left
        }
    }); })
}); }); };
